/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ActorChangeHistoryDay,
  ActorChangeHistoryMonth,
  ApiUserTasksGetPageParameter,
  EntityChangeHistoryRecord,
  ProblemDetails,
  StudioActivityDay,
  StudioActivityMonth,
  TeamActivityToday,
} from '../models/index';
import {
    ActorChangeHistoryDayFromJSON,
    ActorChangeHistoryDayToJSON,
    ActorChangeHistoryMonthFromJSON,
    ActorChangeHistoryMonthToJSON,
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterToJSON,
    EntityChangeHistoryRecordFromJSON,
    EntityChangeHistoryRecordToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    StudioActivityDayFromJSON,
    StudioActivityDayToJSON,
    StudioActivityMonthFromJSON,
    StudioActivityMonthToJSON,
    TeamActivityTodayFromJSON,
    TeamActivityTodayToJSON,
} from '../models/index';

export interface ApiEntityChangeHistoryActivityDayGetRequest {
    userId?: ApiUserTasksGetPageParameter;
    date?: Date;
    xTenantID?: number;
}

export interface ApiEntityChangeHistoryActivityStudioDayGetRequest {
    date?: Date;
    xTenantID?: number;
}

export interface ApiEntityChangeHistoryActivityStudioSummaryGetRequest {
    year?: ApiUserTasksGetPageParameter;
    month?: ApiUserTasksGetPageParameter;
    xTenantID?: number;
}

export interface ApiEntityChangeHistoryActivitySummaryGetRequest {
    userId?: ApiUserTasksGetPageParameter;
    year?: ApiUserTasksGetPageParameter;
    month?: ApiUserTasksGetPageParameter;
    xTenantID?: number;
}

export interface ApiEntityChangeHistoryActivityTeamGetRequest {
    xTenantID?: number;
}

export interface ApiEntityChangeHistoryGetRequest {
    entityName?: string;
    entityId?: string;
    xTenantID?: number;
}

/**
 * 
 */
export class EntityChangeHistoryApi extends runtime.BaseAPI {

    /**
     * Returns the change-history rows that employee wrote on the studio calendar day, oldest first. Each row names the person and the class or appointment it belongs to when those records still exist.
     * List an employee\'s changes for one studio day
     */
    async apiEntityChangeHistoryActivityDayGetRaw(requestParameters: ApiEntityChangeHistoryActivityDayGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActorChangeHistoryDay>> {
        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['date'] != null) {
            queryParameters['date'] = (requestParameters['date'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/entity-change-history/activity/day`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActorChangeHistoryDayFromJSON(jsonValue));
    }

    /**
     * Returns the change-history rows that employee wrote on the studio calendar day, oldest first. Each row names the person and the class or appointment it belongs to when those records still exist.
     * List an employee\'s changes for one studio day
     */
    async apiEntityChangeHistoryActivityDayGet(requestParameters: ApiEntityChangeHistoryActivityDayGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActorChangeHistoryDay> {
        const response = await this.apiEntityChangeHistoryActivityDayGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the saves every employee made on the studio calendar day. Each row includes the employee id when the account still exists.
     * List the studio\'s changes for one day
     */
    async apiEntityChangeHistoryActivityStudioDayGetRaw(requestParameters: ApiEntityChangeHistoryActivityStudioDayGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StudioActivityDay>> {
        const queryParameters: any = {};

        if (requestParameters['date'] != null) {
            queryParameters['date'] = (requestParameters['date'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/entity-change-history/activity/studio/day`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StudioActivityDayFromJSON(jsonValue));
    }

    /**
     * Returns the saves every employee made on the studio calendar day. Each row includes the employee id when the account still exists.
     * List the studio\'s changes for one day
     */
    async apiEntityChangeHistoryActivityStudioDayGet(requestParameters: ApiEntityChangeHistoryActivityStudioDayGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StudioActivityDay> {
        const response = await this.apiEntityChangeHistoryActivityStudioDayGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns how many saves the studio made on each studio day. Days with no changes are omitted. One response covers every employee.
     * Count the studio\'s changes for a month
     */
    async apiEntityChangeHistoryActivityStudioSummaryGetRaw(requestParameters: ApiEntityChangeHistoryActivityStudioSummaryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StudioActivityMonth>> {
        const queryParameters: any = {};

        if (requestParameters['year'] != null) {
            queryParameters['year'] = requestParameters['year'];
        }

        if (requestParameters['month'] != null) {
            queryParameters['month'] = requestParameters['month'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/entity-change-history/activity/studio/summary`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StudioActivityMonthFromJSON(jsonValue));
    }

    /**
     * Returns how many saves the studio made on each studio day. Days with no changes are omitted. One response covers every employee.
     * Count the studio\'s changes for a month
     */
    async apiEntityChangeHistoryActivityStudioSummaryGet(requestParameters: ApiEntityChangeHistoryActivityStudioSummaryGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StudioActivityMonth> {
        const response = await this.apiEntityChangeHistoryActivityStudioSummaryGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns how many change-history rows that employee wrote on each studio day. Days with no changes are omitted.
     * Count an employee\'s changes for a studio month
     */
    async apiEntityChangeHistoryActivitySummaryGetRaw(requestParameters: ApiEntityChangeHistoryActivitySummaryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActorChangeHistoryMonth>> {
        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['year'] != null) {
            queryParameters['year'] = requestParameters['year'];
        }

        if (requestParameters['month'] != null) {
            queryParameters['month'] = requestParameters['month'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/entity-change-history/activity/summary`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActorChangeHistoryMonthFromJSON(jsonValue));
    }

    /**
     * Returns how many change-history rows that employee wrote on each studio day. Days with no changes are omitted.
     * Count an employee\'s changes for a studio month
     */
    async apiEntityChangeHistoryActivitySummaryGet(requestParameters: ApiEntityChangeHistoryActivitySummaryGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActorChangeHistoryMonth> {
        const response = await this.apiEntityChangeHistoryActivitySummaryGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns teachers and staff with how many change-history rows they wrote on the studio\'s current day.
     * Count what each employee changed today
     */
    async apiEntityChangeHistoryActivityTeamGetRaw(requestParameters: ApiEntityChangeHistoryActivityTeamGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TeamActivityToday>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/entity-change-history/activity/team`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TeamActivityTodayFromJSON(jsonValue));
    }

    /**
     * Returns teachers and staff with how many change-history rows they wrote on the studio\'s current day.
     * Count what each employee changed today
     */
    async apiEntityChangeHistoryActivityTeamGet(requestParameters: ApiEntityChangeHistoryActivityTeamGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TeamActivityToday> {
        const response = await this.apiEntityChangeHistoryActivityTeamGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Admin and Staff can read any entity. A choreographer can read history only for their own dance, and internal notes are left out.
     * Get change history for an entity
     */
    async apiEntityChangeHistoryGetRaw(requestParameters: ApiEntityChangeHistoryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EntityChangeHistoryRecord>>> {
        const queryParameters: any = {};

        if (requestParameters['entityName'] != null) {
            queryParameters['entityName'] = requestParameters['entityName'];
        }

        if (requestParameters['entityId'] != null) {
            queryParameters['entityId'] = requestParameters['entityId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/entity-change-history`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EntityChangeHistoryRecordFromJSON));
    }

    /**
     * Admin and Staff can read any entity. A choreographer can read history only for their own dance, and internal notes are left out.
     * Get change history for an entity
     */
    async apiEntityChangeHistoryGet(requestParameters: ApiEntityChangeHistoryGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EntityChangeHistoryRecord>> {
        const response = await this.apiEntityChangeHistoryGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
